var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alpheios-ib" }, [
    _c("div", { staticClass: "alpheios-ib__lang-cont" }, [
      _c(
        "div",
        {
          staticClass: "alpheios-ib__title alpheios-clickable",
          class: { open: !_vm.collapsed[_vm.constants.LANG_LATIN.toString()] },
          on: {
            click: function ($event) {
              return _vm.collapseLanguage(_vm.constants.LANG_LATIN)
            },
          },
        },
        [
          _vm._v("\n      Latin Inflection Browser\n      "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.collapsed[_vm.constants.LANG_LATIN.toString()],
                  expression: "collapsed[constants.LANG_LATIN.toString()]",
                },
              ],
            },
            [_vm._v("[+]")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.collapsed[_vm.constants.LANG_LATIN.toString()],
                  expression: "!collapsed[constants.LANG_LATIN.toString()]",
                },
              ],
            },
            [_vm._v("[-]")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.collapsed[_vm.constants.LANG_LATIN.toString()],
              expression: "!collapsed[constants.LANG_LATIN.toString()]",
            },
          ],
        },
        [
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Nouns"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("lat", "noun"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "lat", "noun"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Adjectives"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("lat", "adjective"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "lat", "adjective"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Verbs"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l2" }, [
            _vm._v("Regular verbs"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("Sorted by..."),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("lat", "verb"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "lat", "verb"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("Other Forms"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("lat", "other verb forms"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "lat", "other verb forms"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l2" }, [
            _vm._v("Irregular verbs"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("lat", "irregular verbs"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "lat", "irregular verbs"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "alpheios-ib__lang-cont" }, [
      _c(
        "div",
        {
          staticClass: "alpheios-ib__title alpheios-clickable",
          class: { open: !_vm.collapsed[_vm.constants.LANG_GREEK.toString()] },
          on: {
            click: function ($event) {
              return _vm.collapseLanguage(_vm.constants.LANG_GREEK)
            },
          },
        },
        [
          _vm._v("\n      Greek Inflection Browser\n      "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.collapsed[_vm.constants.LANG_GREEK.toString()],
                  expression: "collapsed[constants.LANG_GREEK.toString()]",
                },
              ],
            },
            [_vm._v("[+]")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.collapsed[_vm.constants.LANG_GREEK.toString()],
                  expression: "!collapsed[constants.LANG_GREEK.toString()]",
                },
              ],
            },
            [_vm._v("[-]")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.collapsed[_vm.constants.LANG_GREEK.toString()],
              expression: "!collapsed[constants.LANG_GREEK.toString()]",
            },
          ],
        },
        [
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Nouns"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("grc", "noun"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "grc", "noun"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Adjectives"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("grc", "adjective"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "grc", "adjective"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Pronouns"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("grc", "pronoun"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "grc", "pronoun"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Articles"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("grc", "article"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "grc", "article"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Numerals"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("grc", "numeral"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "grc", "numeral"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title" }, [
            _vm._v("Verb Paradigms"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l2" }, [
            _vm._v("ω Verbs"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("Regular ω Verbs"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("grc", "regular verbs"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "grc", "regular verbs"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("Athematic Perfects"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("grc", "athematic perfects"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "grc", "athematic perfects"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("Present System of Contract Verbs (-εω, -αω, -οω)"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("grc", "contract verbs"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "grc", "contract verbs"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l2" }, [
            _vm._v("μι Verbs"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("τίθημι"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("grc", "mi verbs - tithimi"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "grc", "mi verbs - tithimi"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("ἵημι"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("grc", "mi verbs - iimi"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "grc", "mi verbs - iimi"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("δίδωμι"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("grc", "mi verbs - didomi"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "grc", "mi verbs - didomi"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("ἵστημι"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("grc", "mi verbs - istimi"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "grc", "mi verbs - istimi"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l3" }, [
            _vm._v("Other"),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.getTables("grc", "mi verbs - other"),
            function (table, index) {
              return _c("wide-table", {
                key: _vm.getIndex(index, "grc", "mi verbs - other"),
                attrs: {
                  collapsed: _vm.inflBrowserTablesCollapsed,
                  "standard-form-data": table,
                },
              })
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-ib__pofs-title-l2" }, [
            _vm._v("Participles"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getTables("grc", "participle"), function (table, index) {
            return _c("wide-table", {
              key: _vm.getIndex(index, "grc", "participle"),
              attrs: {
                collapsed: _vm.inflBrowserTablesCollapsed,
                "standard-form-data": table,
              },
            })
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }